import { head, isNil, isNumber } from 'lodash-es';
import { PREWAGER_PAYMENT_SYSTEM_ID, SINGLE_WALLET_ID } from '../../constants';
import getPreWagerBalance from '../getPreWagerBalance';

const configureWallets = (rawWallets) => {
  const psIds = [PREWAGER_PAYMENT_SYSTEM_ID, SINGLE_WALLET_ID];
  const wallets = rawWallets.filter(({ paymentInstrumentId }) =>
    psIds.includes(paymentInstrumentId)
  );

  const activeWallet = head(wallets);
  const { deposit: currentDeposit } = activeWallet;
  const preWagerWallet = getPreWagerBalance(wallets) || {};
  const { deposit: bonusBalance } = preWagerWallet;

  return {
    currencies: wallets.reduce((acc, { currency }) => {
      return acc.includes(currency) ? acc : [...acc, currency];
    }, []),
    wallets,
    activeWallet: {
      ...activeWallet,
      isActive: 1,
      baseBalance: currentDeposit || 0,
      bonusBalance: isNumber(bonusBalance) ? Number(bonusBalance) : null,
      deposit: !isNil(bonusBalance)
        ? Number(currentDeposit) + Number(bonusBalance)
        : currentDeposit
    }
  };
};

export default configureWallets;
